<template>
    <div class="vx-col md:w-full sm:w-auto">
        <vx-tooltip text="Phê duyệt" position="top" color="primary" v-if="params.data.status == 0 && isPermissionAssign()">
            <feather-icon icon="CheckIcon" class="ml-0 mr-4 action-success icon-btn"
                            svgClasses="h-5 w-5 hover:text-primary cursor-pointer"
                            @click="confirmAcceptLeave"/>
        </vx-tooltip>

        <vx-tooltip text="Từ chối" position="top" color="primary" v-if="params.data.status == 0 && isPermissionAssign()">
            <feather-icon icon="XIcon" class="ml-0 mr-4 action-err icon-btn"
                            svgClasses="h-5 w-5 hover:text-danger cursor-pointer"
                            @click="confirmRejectLeave"/>
        </vx-tooltip>

        <vx-tooltip text="Chỉnh sửa" position="top" color="primary">
            <feather-icon icon="EditIcon" class="ml-0 action-success icon-btn"
                            svgClasses="h-5 w-5 hover:text-primary cursor-pointer"
                            @click="editRecord"/>
        </vx-tooltip>
    </div>
</template>

<script>
import {isAPI} from "../../../../../store/permission";
import {constAPI} from "../../../../../store/constant";

export default {
    name: 'CellRendererActions',
    methods: {
        isPermissionAssign(){
            return isAPI(this, constAPI.leave_assign);
        },
        editRecord() {
            this.$router.push(`/user/edit-leave?branch_id=${this.params.data.organizationBranchId}&id=${this.params.data.id}`).catch(() => {
            })
        },
        confirmAcceptLeave() {
            this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: `Xác nhận duyệt`,
                text: `Bạn có chắc là muốn duyệt đơn xin nghỉ của nhân viên "${this.params.data.fullName}" không ? `,
                accept: this.acceptLeave,
                acceptText: "Xác nhận",
                cancelText: "Huỷ"
            })
        },
        acceptLeave() {
            this.$vs.loading();
            this.$crm.post('/leave/update/' + this.params.data.id, {status: 1}).then(() => {
                this.$vs.loading.close();
                this.showUpdateSuccess(true);
                this.$store.commit('UPDATE_LEAVE', true);
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },
        confirmRejectLeave() {
            this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: `Xác nhận từ chối`,
                text: `Bạn có chắc là muốn từ chối đơn xin nghỉ của nhân viên "${this.params.data.fullName}" không ? `,
                accept: this.acceptCancelLeave,
                acceptText: "Xác nhận",
                cancelText: "Huỷ"
            })
        },
        acceptCancelLeave() {
            this.$vs.loading();
            this.$crm.post('/leave/update/' + this.params.data.id, {status: 2}).then(() => {
                this.$vs.loading.close();
                this.showUpdateSuccess(false);
                this.$store.commit('UPDATE_LEAVE', true);
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },
        showUpdateSuccess(check) {
            this.$vs.notify({
                color: 'success',
                text: `${check ? 'Duyệt' : 'Từ chối'} đơn xin nghỉ thành công!`,
                iconPack: 'feather',
                icon: 'icon-alert-circle',
            })
        }
    }
}
</script>

<style scoped>


</style>
